/* eslint-disable no-unused-vars */
import { useEffect, useState, useMemo, useRef } from 'react';
import { Card, Row, Col, Form, Input,} from 'antd';
import { useHistory, useLocation } from "react-router-dom";
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import  Validations from 'shared/validations/Validations.json';
import PackingListResults from '../PackingListResults';
import { layout, ParcelAndPacking, SearchAndNewPacking } from './SearchPacking';

export default function SearchPackingList() {
    const history = useHistory();
    const { search } = useLocation()
    const obdTypeId = 1 ;
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const [endPoint, setEndPoint] = useState()
    const myRef = useRef();
    const [form] = Form.useForm();

    const navigateToNewPackingList = () => {
        history.push({pathname : '/choices/new-packageObd',state:'Obd'}) 
    } 

    useEffect(() => {
        form.setFieldsValue({
            'deviceImei': queryParams.get('deviceImei'),
            'simImsi': queryParams.get('simImsi'),
            'parcelId': queryParams.get('parcelId'),
            'PackingStatusId': queryParams.get('PackingStatusId'),
        })
        setEndPoint(`${EndPoints.PACKING.GETPACKINGLISTOBD}?${queryParams.toString()}`);
    }, [queryParams, form])

    const onFinish =(fieldsValues) => {
        const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });
        const values = {
            ...fieldsValues,
        }
        Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' ? delete values[key] : values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        setEndPoint(`${EndPoints.PACKING.GETPACKINGLISTOBD}?${params}`);
        executeScroll();
    }


    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση">
                <SearchAndNewPacking navigateToNewPackingList={navigateToNewPackingList}/>
                <Form form={form} onFinish={onFinish} {...layout} >
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                name="deviceImei"
                                label="ΙΜΕΙ Συσκευής:"
                                rules={[
                                    {
                                        pattern: new RegExp(Validations.DEVICEIMEI.REGEX),
                                        message: Validations.DEVICEIMEI.MESSAGE
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="simImsi"
                                label="ΙΜSΙ SIM Κάρτας:"
                                rules={[
                                    {
                                        pattern: new RegExp(Validations.IMSISIM.REGEX),
                                        message: Validations.IMSISIM.MESSAGE
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <ParcelAndPacking />                     
                    </Row>
                </Form>
            </Card>
            <Col ref={myRef}>
                <PackingListResults endPoint={endPoint} deviceTypeId={obdTypeId} />
            </Col>
        </>
    );
}